export type FeedbackSource = "auto" | "manual";

export interface UserFeedbackPayload {
  score: number;
  comment?: string;
  source: FeedbackSource;
}

export interface UserFeedbackRecord {
  id: number;
  user_id: number;
  score: number;
  comment: string;
  source: string;
}

const getFeedbackEndpoint = (baseUrl: string | undefined): string => {
  if (!baseUrl) throw new Error("baseUrl is required");
  return `${baseUrl}/api/v1/portal_feedback/`;
};

const getPortalFeedbackHeaders = (
  accessToken?: string,
): Record<string, string> => {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  return headers;
};

export const SubmitUserFeedback = async (
  feedbackData: UserFeedbackPayload,
  baseUrl: string | undefined,
  accessToken?: string,
): Promise<Response> =>
  fetch(getFeedbackEndpoint(baseUrl), {
    body: JSON.stringify(feedbackData),
    method: "POST",
    headers: getPortalFeedbackHeaders(accessToken),
  });

export const GetUserFeedback = async (
  baseUrl: string | undefined,
  accessToken?: string,
): Promise<Response> =>
  fetch(getFeedbackEndpoint(baseUrl), {
    method: "GET",
    headers: getPortalFeedbackHeaders(accessToken),
  });
